import { AnyAction } from 'redux';
import {
  BACKOFFICE_LOGIN_RECEIVED,
  BACKOFFICE_LOGIN_SET_CODE,
  BACKOFFICE_LOGIN_SET_IS_LOADING,
  BACKOFFICE_LOGIN_SET_REDIRECT_URL,
  BACKOFFICE_LOGIN_SET_USERNAME_PASSWORD,
} from '../constants';

export interface BackofficeLoginState {
  username?: string;
  redirectUrl?: string;
  showQrCode?: boolean;
  showCodeInput?: boolean;
  qrCode?: string;
  isFirstTimeSetup?: boolean;
  success?: boolean;
  failed?: boolean;
  isAuthenticated?: boolean;
  isLoading?: boolean;
  loginToken?: string;
  error?: {
    Login?: string;
    Code?: string;
    Unauthorized?: string;
    General?: string;
  } | null;
}

const DEFAULT_STATE: BackofficeLoginState = {
  isAuthenticated: false,
};

export const backofficeLogin = (
  state = DEFAULT_STATE,
  action: AnyAction
): BackofficeLoginState => {
  switch (action.type) {
    case BACKOFFICE_LOGIN_RECEIVED:
      return {
        ...state,
        error: action.payload.error,
        ...action.payload.backofficeLogin,
      };
    case BACKOFFICE_LOGIN_SET_USERNAME_PASSWORD:
    case BACKOFFICE_LOGIN_SET_IS_LOADING:
    case BACKOFFICE_LOGIN_SET_REDIRECT_URL:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
